import { render, staticRenderFns } from "./RoomScene.vue?vue&type=template&id=528d7038&scoped=true&"
import script from "./RoomScene.vue?vue&type=script&lang=js&"
export * from "./RoomScene.vue?vue&type=script&lang=js&"
import style0 from "./RoomScene.vue?vue&type=style&index=0&id=528d7038&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528d7038",
  null
  
)

export default component.exports